export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/seller_page_perseus/mask_top_left.b837757.svg";